import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

import store from './store/index'
import Top from './components/Top.vue'

Vue.use(VueLazyload, {
  src: '/static/img/common/spacer.gif',
  loading: '/static/img/common/spacer.gif'
})

// eslint-disable-next-line no-unused-vars
const vm = new Vue({
  store,
  el: '#vuejs-game-list',
  components: {
    'game-list': Top
  }
})
